import {
  NotificationTypeSchema,
  type NotificationType as GeneratedNotificationType
} from '~/services/api/generated'

// Mirrors backend App\Enums\Notification\NotificationType

export type NotificationType = GeneratedNotificationType

export const NotificationType = {
  NEW_ORDER: NotificationTypeSchema.enum.new_order,
  ORDER_UPDATES: NotificationTypeSchema.enum.order_updates,
  ORDER_REQUEST_RECEIVED: NotificationTypeSchema.enum.order_request_received,
  PAYMENT_REQUEST: NotificationTypeSchema.enum.payment_request,
  PAYMENT_COMPLETED: NotificationTypeSchema.enum.payment_completed,
  ORDER_DECLINED: NotificationTypeSchema.enum.order_declined,
  PAYOUT_RECEIVED: NotificationTypeSchema.enum.payout_received,
  NEW_STORE_REVIEW: NotificationTypeSchema.enum.new_store_review,
  STORE_UPDATES: NotificationTypeSchema.enum.store_updates,
  DAILY_SUMMARY: NotificationTypeSchema.enum.daily_summary,
  WEEKLY_REPORT: NotificationTypeSchema.enum.weekly_report
} satisfies Record<string, GeneratedNotificationType>

export const NotificationTypeValues: readonly GeneratedNotificationType[] = [
  NotificationTypeSchema.enum.new_order,
  NotificationTypeSchema.enum.order_updates,
  NotificationTypeSchema.enum.order_request_received,
  NotificationTypeSchema.enum.payment_request,
  NotificationTypeSchema.enum.payment_completed,
  NotificationTypeSchema.enum.order_declined,
  NotificationTypeSchema.enum.payout_received,
  NotificationTypeSchema.enum.new_store_review,
  NotificationTypeSchema.enum.store_updates,
  NotificationTypeSchema.enum.daily_summary,
  NotificationTypeSchema.enum.weekly_report
]
